import { useEffect } from 'react';
import { resolveBrand } from '@/config/branding';

export const usePageTitle = (title: string) => {
  const appName = resolveBrand().name;

  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} - ${appName}` : appName;

    return () => {
      document.title = previousTitle;
    };
  }, [title, appName]);
};
